import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { useCushionChargePoliciesQuery } from 'queries/company'

export type CushionChargePolicyItem = NonNullable<
  ReturnType<typeof useCushionChargePoliciesQuery>['data']
>['items'][number]

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type EditCushionChargePolicyWorkflow = {
  open: (policy: CushionChargePolicyItem) => void
  close: () => void
  isOpen: boolean
  policy: CushionChargePolicyItem | null
}

export type CushionChargePoliciesWorkflowsContextState = {
  createCushionChargePolicyFlow: Workflow
  editCushionChargePolicyFlow: EditCushionChargePolicyWorkflow
}

const [Context, useCushionChargePoliciesWorkflowsContextValue] =
  createContext<CushionChargePoliciesWorkflowsContextState>({
    name: 'CushionChargePoliciesWorkflowsContext',
  })

export const CushionChargePoliciesWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [policy, setPolicy] = useState<CushionChargePolicyItem | null>(null)

  const value: CushionChargePoliciesWorkflowsContextState = {
    createCushionChargePolicyFlow: {
      open: () => setIsCreateOpen(true),
      close: () => setIsCreateOpen(false),
      isOpen: isCreateOpen,
    },
    editCushionChargePolicyFlow: {
      open: (nextPolicy) => {
        setPolicy(nextPolicy)
        setIsEditOpen(true)
      },
      close: () => setIsEditOpen(false),
      isOpen: isEditOpen,
      policy,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCushionChargePoliciesWorkflowsContextValue }
